
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-highlight disabled-highlight",attrs:{"d":"M12 6.4c1.764 0 3.2-1.436 3.2-3.2C15.2 1.436 13.764 0 12 0a3.204 3.204 0 00-3.2 3.2c0 1.764 1.436 3.2 3.2 3.2zm0-5.6c1.324 0 2.4 1.076 2.4 2.4 0 1.324-1.076 2.4-2.4 2.4a2.402 2.402 0 01-2.4-2.4C9.6 1.876 10.676.8 12 .8z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M12 17.6a3.204 3.204 0 00-3.2 3.2c0 1.764 1.436 3.2 3.2 3.2 1.764 0 3.2-1.436 3.2-3.2 0-1.764-1.436-3.2-3.2-3.2zm0 5.6a2.402 2.402 0 01-2.4-2.4c0-1.324 1.076-2.4 2.4-2.4 1.324 0 2.4 1.076 2.4 2.4 0 1.324-1.076 2.4-2.4 2.4zM12 8.8A3.204 3.204 0 008.8 12c0 1.764 1.436 3.2 3.2 3.2 1.764 0 3.2-1.436 3.2-3.2 0-1.764-1.436-3.2-3.2-3.2zm0 5.6A2.402 2.402 0 019.6 12c0-1.324 1.076-2.4 2.4-2.4 1.324 0 2.4 1.076 2.4 2.4 0 1.324-1.076 2.4-2.4 2.4z","fill":"#00003C"}})])
          )
        }
      }
    